/**
 * Gestion accessible de la navigation mobile (a11y)
 *
 * @package Sountsou2026
 */

export function initNavigation() {
    const nav = document.getElementById('site-navigation');
    if (!nav) return;

    const toggle = nav.querySelector('.site-nav__toggle');
    const menuWrapper = nav.querySelector('.site-nav__menu-wrapper');
    const menuList = nav.querySelector('.site-nav__list');

    if (!toggle || !menuWrapper) return;

    function openMenu() {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Fermer le menu');
        nav.classList.add('is-open');
        document.body.classList.add('menu-is-open');

        // Focus sur le premier lien du menu pour les utilisateurs clavier/lecteurs d'écran
        const firstLink = menuWrapper.querySelector('a');
        if (firstLink) {
            firstLink.focus();
        }
    }

    function closeMenu(restoreFocus = true) {
        if (toggle.getAttribute('aria-expanded') !== 'true') return;

        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Ouvrir le menu');
        nav.classList.remove('is-open');
        document.body.classList.remove('menu-is-open');

        if (restoreFocus) {
            toggle.focus();
        }
    }

    // Bascule lors du clic sur le bouton toggle
    toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
            closeMenu(false);
        } else {
            openMenu();
        }
    });

    // Fermeture avec la touche Échap (Escape)
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            closeMenu(true);
        }
    });

    // Fermeture lors d'un clic à l'extérieur
    document.addEventListener('click', function (e) {
        if (toggle.getAttribute('aria-expanded') === 'true' && !nav.contains(e.target)) {
            closeMenu(false);
        }
    });

    // Fermeture automatique lors du passage en mode desktop (> 1024px)
    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    const handleBreakpoint = (e) => {
        if (e.matches) {
            closeMenu(false);
        }
    };
    if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleBreakpoint);
    } else if (mediaQuery.addListener) {
        mediaQuery.addListener(handleBreakpoint);
    }
}
